// Mapping des étapes de progression AAC → composants pédagogiques interactifs
// PHILOSOPHIE : seuls les visuels au niveau "pilote qualité pro" (composant React
// dédié, dessin SVG soigné, panneau explicatif riche, interactivité pensée) sont
// exposés à l'utilisateur. Les autres étapes n'affichent PAS de bouton
// "Visuel interactif" — on les activera au fur et à mesure qu'un pilote sera
// produit à la qualité requise.
import AnglesMortsSvg from '../components/svg-pilots/AnglesMortsSvg';
import DemarrerSarreterSvg from '../components/svg-pilots/DemarrerSarreterSvg';
import IntersectionsSvg from '../components/svg-pilots/IntersectionsSvg';
import GiratoiresSvg from '../components/svg-pilots/GiratoiresSvg';
import PointPatinageSvg from '../components/svg-pilots/PointPatinageSvg';
import ConduiteCommenteeSvg from '../components/svg-pilots/ConduiteCommenteeSvg';
import RetroInterieurSvg from '../components/svg-pilots/RetroInterieurSvg';
import RetroTousSvg from '../components/svg-pilots/RetroTousSvg';
import InsertionCentreVilleSvg from '../components/svg-pilots/InsertionCentreVilleSvg';
import VoiesAccelDecelSvg from '../components/svg-pilots/VoiesAccelDecelSvg';
import InstallationPosteSvg from '../components/svg-pilots/InstallationPosteSvg';
import CommandesSvg from '../components/svg-pilots/CommandesSvg';
import VolantChausseeSvg from '../components/svg-pilots/VolantChausseeSvg';
import BoiteVitessesSvg from '../components/svg-pilots/BoiteVitessesSvg';
import ManoeuvresSvg from '../components/svg-pilots/ManoeuvresSvg';
import DemarrageCoteSvg from '../components/svg-pilots/DemarrageCoteSvg';
import ControlesSequenceSvg from '../components/svg-pilots/ControlesSequenceSvg';

// Wrappers pour partager BoiteVitessesSvg et ManoeuvresSvg entre plusieurs étapes
const M5Svg  = () => <BoiteVitessesSvg stepId="M5" />;
const M6Svg  = () => <BoiteVitessesSvg stepId="M6" />;
const M7Svg  = () => <BoiteVitessesSvg stepId="M7" />;
const M10Svg = () => <BoiteVitessesSvg stepId="M10" />;
const M8Svg  = () => <ManoeuvresSvg    stepId="M8" />;
const M9Svg  = () => <ManoeuvresSvg    stepId="M9" />;

export const STEP_SVG_MAP = {
  // ⭐ PILOTES QUALITÉ PRO — composants React interactifs
  M1:  { component: InstallationPosteSvg,  isPilot: true, label: 'Installation poste conduite — pilote qualité' },
  M2:  { component: CommandesSvg,          isPilot: true, label: 'Principales commandes — pilote qualité' },
  M3:  { component: VolantChausseeSvg,     isPilot: true, label: 'Volant + positionnement chaussée — pilote qualité' },
  M4:  { component: DemarrerSarreterSvg,   isPilot: true, label: 'Démarrer & s\'arrêter — pilote qualité' },
  M5:  { component: M5Svg,                 isPilot: true, label: '1re → 2e — pilote qualité' },
  M6:  { component: M6Svg,                 isPilot: true, label: '1re → 3e — pilote qualité' },
  M7:  { component: M7Svg,                 isPilot: true, label: 'Rétrograder 3e → 2e — pilote qualité' },
  M8:  { component: M8Svg,                 isPilot: true, label: 'Marche arrière — pilote qualité' },
  M9:  { component: M9Svg,                 isPilot: true, label: 'Demi-tour — pilote qualité' },
  M10: { component: M10Svg,                isPilot: true, label: 'Vitesses jusqu\'en 5e — pilote qualité' },
  M11: { component: DemarrageCoteSvg,      isPilot: true, label: 'Démarrage en côte — pilote qualité' },
  M12: { component: PointPatinageSvg,      isPilot: true, label: 'Point de patinage — pilote qualité' },
  M13: { component: IntersectionsSvg,      isPilot: true, label: 'Détection intersections — pilote qualité' },
  O1:  { component: ConduiteCommenteeSvg,  isPilot: true, label: 'Conduite commentée — pilote qualité' },
  O2:  { component: RetroInterieurSvg,     isPilot: true, label: 'Rétroviseur intérieur — pilote qualité' },
  O3:  { component: RetroTousSvg,          isPilot: true, label: 'Tous les rétroviseurs — pilote qualité' },
  O4:  { component: AnglesMortsSvg,        isPilot: true, label: 'Angles morts — pilote qualité' },
  O5:  { component: GiratoiresSvg,         isPilot: true, label: 'Les giratoires — pilote qualité' },
  O6:  { component: InsertionCentreVilleSvg, isPilot: true, label: 'Insertion centre ville — pilote qualité' },
  O7:  { component: VoiesAccelDecelSvg,    isPilot: true, label: 'Voies accél. / décél. — pilote qualité' },
  O8:  { component: ControlesSequenceSvg,  isPilot: true, label: 'Séquence des contrôles MSM — pilote qualité' },
  // Les autres étapes n'ont PAS encore de visuel au niveau requis.
};

export function getStepSvg(stepId) {
  return STEP_SVG_MAP[stepId] || null;
}

// Type helpers
export function isPilotStep(stepId) {
  const val = STEP_SVG_MAP[stepId];
  return val && typeof val === 'object' && val.isPilot;
}
